import { Action } from "redux";
import { OrganizationKeyName } from "../../../model/Organization";
import { AdminErrorListResponseData } from "../../../service/api-response/AdminFormErrorResponse";

export const INSERT_VENUE_FAIL = "INSERT_VENUE_FAIL";

export interface InsertVenueFailAction extends Action {
  type: typeof INSERT_VENUE_FAIL;
  errors?: AdminErrorListResponseData;
  organization: OrganizationKeyName;
}

export const insertVenueFailAction = (
  organization: OrganizationKeyName,
  errors?: AdminErrorListResponseData
): InsertVenueFailAction => ({
  type: INSERT_VENUE_FAIL,
  errors,
  organization,
});
